var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _polygon, _polygon2, _path8, _path9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1036,
    height: 569.97133,
    viewBox: "0 0 1036 569.97133",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Books") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.03638,460.85116c0,105.97579-85.91829,191.89415-191.89415,191.89415V268.957C189.11809,268.957,275.03638,354.87529,275.03638,460.85116Z",
    transform: "translate(-82 -165.01433)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M924.96362,460.85116c0,105.97579,85.91829,191.89415,191.89415,191.89415V268.957C1010.88191,268.957,924.96362,354.87529,924.96362,460.85116Z",
    transform: "translate(-82 -165.01433)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.23657,245.89659a13.70673,13.70673,0,1,1,13.70672-13.70673A13.72244,13.72244,0,0,1,269.23657,245.89659Zm0-25.129a11.42227,11.42227,0,1,0,11.42227,11.42227A11.435,11.435,0,0,0,269.23657,220.76759Z",
    transform: "translate(-82 -165.01433)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M878.989,601.46031H856.4401V578.91144H878.989Zm-20.81434-1.73453h19.07982V580.646H858.17463Z",
    transform: "translate(-82 -165.01433)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.73544,580.99169l-15.38019-16.48943,16.48943-15.3802,15.38019,16.48944Zm-12.92868-16.40411,13.014,13.9526,13.95259-13.014-13.014-13.9526Z",
    transform: "translate(-82 -165.01433)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82,165.01433V734.98567H1118V165.01433ZM1115.71555,732.70121H84.28445V167.29879h1031.4311Z",
    transform: "translate(-82 -165.01433)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M856.89787,734.41455q-37.04832-5.79987-71.24294-9.86652l8.77843-17.55692c-3.047-1.01568-16.25092,9.14115-16.25092,9.14115L789.355,665.34811c-15.23525,2.03136-22.345,53.8312-22.345,53.8312L749.74331,701.9127l8.49959,19.549c-69.7584-7.32985-129.95337-9.61731-180.55371-9.09267l7.51347-15.02689c-3.047-1.01568-16.25092,9.14115-16.25092,9.14115l11.17251-50.78415c-15.23525,2.03137-22.345,53.8312-22.345,53.8312l-17.26661-17.26661,9.00241,20.70557a1013.49859,1013.49859,0,0,0-103.6226,8.34474c7.49729-23.35644,33.67921-45.80908,33.67921-45.80908-20.1314,6.26309-30.6047,16.46666-36.02556,25.9249a407.85873,407.85873,0,0,1,21.806-141.20492s-40.62732,91.41147-34.53322,152.35245l.77323,10.82523c-35.34514,5.51391-53.08091,11.01195-53.08091,11.01195Z",
    transform: "translate(-82 -165.01433)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 524.42503,
    cy: 287.85888,
    r: 158.76957,
    fill: "#00bfa6",
    opacity: 0.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "459.223 85.873 353.51 214.137 509.965 398.782 614.268 276.156 459.223 85.873",
    fill: "#00bfa6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "459.223 85.873 353.51 214.137 509.965 398.782 614.268 276.156 459.223 85.873",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M439.73866,380.56133h0a53.13136,53.13136,0,0,1,8.61915-11.50844l97.09359-98.43281s33.82807-5.638,40.87559,11.276L462.29072,383.38033Z",
    transform: "translate(-82 -165.01433)",
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M434.8054,378.44707l143.76933,219.8825s14.095,9.86653,28.19007,4.22851l147.29308-99.37L597.603,266.39156,456.6527,376.33282Z",
    transform: "translate(-82 -165.01433)",
    fill: "#00bfa6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 480.03892,
    y: 332.90544,
    width: 111.09199,
    height: 2.28426,
    transform: "translate(-176.28508 210.29789) rotate(-35.7003)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 545.71885,
    y: 372.62133,
    width: 2.28442,
    height: 214.62012,
    transform: "translate(-256.01839 216.30687) rotate(-33.48132)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 608.59471,
    y: 538.69279,
    width: 118.96652,
    height: 2.285,
    transform: "translate(-271.96473 335.92317) rotate(-36.34406)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 656.36553,
    y: 285.21166,
    width: 2.28364,
    height: 214.66085,
    transform: "translate(-188.39818 280.94637) rotate(-34.83794)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 428.26937,
    y: 320.21875,
    width: 151.38646,
    height: 1.4087,
    transform: "translate(-166.32865 260.23205) rotate(-42.54484)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 432.98129,
    y: 321.37736,
    width: 155.49191,
    height: 1.41013,
    transform: "translate(-167.30716 253.62067) rotate(-41.43847)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 437.01734,
    y: 322.42031,
    width: 157.53272,
    height: 1.41026,
    transform: "translate(-169.30193 240.15132) rotate(-39.81273)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.3065,460.85116c-6.48742-2.40493-14.53662-6.512-19.52606-10.86231l3.51655,9.72008h-62.80416v2.28445h62.80423l-3.51662,9.72232C1065.76988,467.36542,1073.81908,463.25831,1080.3065,460.85116Z",
    transform: "translate(-82 -165.01433)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199.64939,459.70893H136.84517l3.51661-9.72232c-4.98943,4.35028-13.03863,8.45739-19.52606,10.86455,6.48743,2.40492,14.53663,6.512,19.52606,10.86231l-3.51654-9.72009h62.80415Z",
    transform: "translate(-82 -165.01433)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.d87775469c565309dcf93f017cf9d182.svg";
export { ForwardRef as ReactComponent };